import { render, staticRenderFns } from "./MonitoringDialogAuditColumnTemplateComponent.vue?vue&type=template&id=071ab1cc&scoped=true&lang=pug"
import script from "./MonitoringDialogAuditColumnTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./MonitoringDialogAuditColumnTemplateComponent.vue?vue&type=script&lang=ts"
import style0 from "./MonitoringDialogAuditColumnTemplateComponent.vue?vue&type=style&index=0&id=071ab1cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071ab1cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('071ab1cc')) {
      api.createRecord('071ab1cc', component.options)
    } else {
      api.reload('071ab1cc', component.options)
    }
    module.hot.accept("./MonitoringDialogAuditColumnTemplateComponent.vue?vue&type=template&id=071ab1cc&scoped=true&lang=pug", function () {
      api.rerender('071ab1cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/firma/MonitoringDialogAuditColumnTemplateComponent.vue"
export default component.exports